// ════════════════════════════════════════════════════════════════════════════
//  useTransferencias.ts  —  Hooks para transferências entre caixas
// ════════════════════════════════════════════════════════════════════════════

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { transferenciasService } from '../services/transferenciasService';
import type { RealizarTransferenciaRequest } from '../types';
import type { CaixaLancamento } from '@/features/caixa/types';

const SEM_TRANSFERENCIAS: CaixaLancamento[] = [];

export const useTransferencias = (dtInicio?: string, dtFim?: string) => {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: ['transferencias', dtInicio, dtFim],
    queryFn:  () => transferenciasService.listar(dtInicio, dtFim),
  });

  const realizar = useMutation({
    mutationFn: (req: RealizarTransferenciaRequest) => transferenciasService.realizar(req),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['transferencias'] });
      qc.invalidateQueries({ queryKey: ['caixa'] });
    },
  });

  return {
    // Referência estável enquanto carrega (a tela pagina/filtra com useMemo).
    transferencias:   query.data ?? SEM_TRANSFERENCIAS,
    isLoading:        query.isLoading,
    error:            query.error,
    realizar:         realizar.mutateAsync,
    isRealizando:     realizar.isPending,
    realizarError:    realizar.error,
  };
};
